$(document).ready(function(){
     $('.eu_energy_label .eg_img').click(function(){
    var EgImgLink = $(this).attr('img_url'); 
    // alert(EgImgLink);
    $('.eg_image_popup .image-box img').attr('src', EgImgLink);
    $('.eg_image_popup').addClass('eg_image_popup_open');
  });  
  $('.eg_image_popup .title-box span.close_btn').click(function(){
     $('.eg_image_popup').removeClass('eg_image_popup_open');
  });
  $('.eg_image_popup .image-box').click(function(event) {
    if ($(event.target).hasClass('image-box')) {
      $('.eg_image_popup').removeClass('eg_image_popup_open');
    } else {
      event.stopPropagation();
    }
  }); 
})